export const MODEL_DATA = {
    id: null,
    name: '',
    toRegister: function (devices, departments, user) {
        return {
            id: this.id,
            name: this.name,
            deviceIds: devices.map(item => item.id),
            departmentIds: departments.map(item => item.id),
            userIds: user.map(item => item.id)
        }
    }
}
